import { render, staticRenderFns } from "./AdultsPrayer.vue?vue&type=template&id=299e81c8&"
import script from "./AdultsPrayer.vue?vue&type=script&lang=js&"
export * from "./AdultsPrayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports